import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ICategorieAddPayload, ICategorieUpdatePayload } from './categorii-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class CategoriiProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listCategoriiURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.list;
    private listDTCategoriiURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.listDT;
    private addCategorieURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.store;
    private updateCategorieURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.update;
    private deleteCategorieURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.changeActive;
    private listStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteCategorii.listActive;

    constructor(private http: HttpClient) { }

    listCategorii() {
        return this.http.get(this.listCategoriiURL);
    }

    listDTCategorii() {
        return this.http.post(this.listDTCategoriiURL, {});
    }

    addCategorie(data: ICategorieAddPayload) {
        return this.http.post(this.addCategorieURL, data);
    }

    updateCategorie(data: ICategorieUpdatePayload) {
        return this.http.put(this.updateCategorieURL, data);
    }

    deleteCategorie(id: number) {
        return this.http.delete(this.deleteCategorieURL + id);
    }

    listStatusActive() {
        return this.http.get(this.listStatusActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
